<template>
  <div class="qr-code-canvas">
    <canvas v-if="value" ref="canvas"></canvas>
    <div v-else class="qr-code-canvas__empty">
      {{ $t('qrCodeCanvas.noValue') }}
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCodeCanvas',
  props: {
    value: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 96,
    },
  },
  watch: {
    value() {
      this.render()
    },
  },
  mounted() {
    this.render()
  },
  updated() {
    this.render()
  },
  methods: {
    render() {
      if (!this.value || !this.$refs.canvas) {
        return
      }
      // toCanvas is callback-based (no promise resolution needed here); a
      // value QR can't encode (extremely unlikely for text/number source
      // values, but possible for a pathological formula result) reports via
      // the error callback instead of throwing, so the cell stays inert
      // rather than crashing.
      QRCode.toCanvas(
        this.$refs.canvas,
        this.value,
        { width: this.size, margin: 1 },
        (error) => {
          if (error) {
            this.clearCanvas()
          }
        }
      )
    },
    clearCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) {
        return
      }
      const context = canvas.getContext('2d')
      context?.clearRect(0, 0, canvas.width, canvas.height)
    },
  },
}
</script>
